import { finalizeLoginSession } from "../../api/client";
import { assignUserRole } from "../../api/roles.js";

export { hasDirectLoginPayload } from "../../utils/loginAuth.js";

export async function completeLenderLogin(
  submittedEmail,
  response,
  loginData,
  remember,
  redirectPath,
  password = null
) {
  const em = String(submittedEmail || "").trim().toLowerCase();

  await finalizeLoginSession({
    email: em,
    password,
    loginResponse: response,
    loginPayload: loginData,
    remember,
    requireCredentials: true,
  });

  const verifiedUser = String(loginData?.user || "").trim().toLowerCase();
  if (!verifiedUser) {
    throw new Error("SESSION_VERIFY_FAILED");
  }
  if (verifiedUser !== em) {
    throw new Error("SESSION_MISMATCH");
  }

  const storage = remember ? localStorage : sessionStorage;
  const otherStorage = remember ? sessionStorage : localStorage;
  storage.setItem("ds_isAuthed", "1");
  storage.setItem("ds_portal", "lender");
  storage.setItem("ds_lender_email", em);
  otherStorage.removeItem("ds_lender_email");

  const lenderRoleKey = `ds_lender_role_assigned_${em}`;
  if (!localStorage.getItem(lenderRoleKey)) {
    try {
      localStorage.setItem(lenderRoleKey, "1");
    } catch { /* ignore */ }
    const roleResult = await assignUserRole(em, "Lender");
    if (roleResult.ok) console.log("✅ Lender role assigned for", em);
    else console.warn("⚠️ Assign Lender role:", roleResult.error);
  }

  window.location.replace(redirectPath || "/lender/overview");
}
